import React ,{Component } from 'react';
import PhysicianList from '../views/physicianlist';
import { physicianActions } from "../../actions";
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

class PhysicianListContainer extends Component {
    constructor(props) {
        super(props);
        this.state={
            isInbox:true
        }
        this.getData = this.getData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        
    }
    componentDidMount(){

        const {dispatch,match} = this.props;
        dispatch(physicianActions.getall());
       
    }

    getData()
    {
        const {dispatch} = this.props;
        dispatch(physicianActions.getall());
    }
    deleteData(id)
    {
        const {dispatch} = this.props;
        var result=window.confirm('آیا مطمئن هستید ؟');
        if(result)
        {
            dispatch(physicianActions.delete(id,physicianActions.getall()));
        }
    }
    
    render() { 

        const {list}=this.props;
        console.log('LIST',list);

        return ( 
           <PhysicianList  deleteHandler={this.deleteData} remoteDataHandler={this.getData} list={list && list.physicianList}></PhysicianList>
         );
    }
}

function mapStateToProps(state) {
    const { objs } = state;
    const { items } = objs;
    //const { queryable } = items;
    return {
        list:items,
        
           
        
    };
} 

export default withRouter(connect(mapStateToProps)(PhysicianListContainer));